<script setup>
import BreezeButton from "@/Components/AuthButton.vue";
import BreezeCheckbox from "@/Components/Checkbox.vue";
import BreezeGuestLayout from "@/Layouts/Guest.vue";
import BreezeInput from "@/Components/Input.vue";
import BreezeLabel from "@/Components/Label.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import { onMounted } from "@vue/runtime-core";

defineProps({
  canResetPassword: Boolean,
  status: String,
  statusErr: String,
});

const form = useForm({
  email: "",
  password: "",
  remember: false,
});

const submit = () => {
  form.post(route("login"), {
    onFinish: () => form.reset("password"),
  });
};

onMounted(() => {
  localStorage.clear();
});
</script>

<template>
  <BreezeGuestLayout>
    <div
      class="w-full sm:max-w-lg mt-6 px-24 py-12 bg-oteoBlue-600 shadow-md overflow-hidden sm:rounded-lg"
    >
      <Head title="Log in" />

      <BreezeValidationErrors class="mb-4 p-6 rounded bg-white" />

      <!-- <div class="text-lg mb-4 font-bold text-sm text-yellow-500">
        Aufgrund von Wartungsarbeiten steht oteo am Donnerstag, den 08. Mai
        2025, voraussichtlich von 13.00 Uhr - 14.00 Uhr nicht zur Verfügung. Wir
        bitten um Ihr Verständnis.
      </div> -->

      <h2 class="text-3xl text-white mb-4">Anmeldung</h2>
      <!--
      <div class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
      </div> -->

      <div
        v-if="statusErr"
        class="mb-4 p-6 rounded bg-white border border-gray-200"
      >
        <div class="font-medium text-red-600">
          Whoops! Etwas ist schiefgelaufen.
        </div>

        <p class="text-red-600">
          {{ statusErr }}
        </p>
      </div>

      <div
        v-if="status"
        class="mb-4 p-6 rounded bg-white border border-gray-200"
      >
        <p class="text-green-600">
          {{ status }}
        </p>
      </div>

      <form @submit.prevent="submit">
        <div>
          <BreezeLabel for="email" value="E-Mail Adresse" />
          <BreezeInput
            id="email"
            type="email"
            class="mt-1 block w-full"
            v-model="form.email"
            required
            autofocus
            autocomplete="email"
          />
        </div>

        <div class="mt-8">
          <BreezeLabel for="password" value="Passwort" />
          <BreezeInput
            id="password"
            type="password"
            class="mt-1 block w-full"
            v-model="form.password"
            required
            autocomplete="current-password"
          />
        </div>

        <BreezeButton
          class="w-full justify-center mt-8"
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Anmelden
        </BreezeButton>

        <!-- <div class="block mt-4">
          <label class="flex items-center">
            <BreezeCheckbox name="remember" v-model:checked="form.remember" />
            <span class="ml-2 text-sm text-white">Angemeldet bleiben</span>
          </label>
        </div> -->

        <div class="flex items-center justify-end mt-4">
          <Link
            v-if="canResetPassword"
            :href="route('password.request')"
            class="underline text-sm text-white hover:text-gray-300"
          >
            Passwort vergessen?
          </Link>
        </div>
      </form>
    </div>

    <div class="mt-12">
      <h4 class="text-xl font-light text-center text-white">
        Das erste Mal hier?
      </h4>

      <a
        href="/register"
        class="inline-flex items-center px-4 py-1 bg-oteoBlue-400 border border-transparent rounded-md font-semibold text-lg text-white hover:bg-oteoBlue-300 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 w-80 justify-center mt-4"
      >
        Jetzt registrieren
      </a>
    </div>
  </BreezeGuestLayout>
</template>
